<div class="incrementor">
  <mat-icon
    (click)="decrement()"
    bsMouseHold="100"
    [delayHold]="250"
    >remove</mat-icon
  >
  <input matInput type="number" [formControl]="incrementControl" [readonly]="validationRodape()" />
  <mat-icon
    (click)="increment()"
    bsMouseHold="100"
    [delayHold]="250"
    >add</mat-icon
  >
</div>
